import { VisibilityEventType } from '@shared-ui/ref-context';
export var onVisibilityChangeCallback = function (setActiveTab, navigationBarTabList) {
  return function (visibilityEvents) {
    Object.keys(visibilityEvents).forEach(function (section) {
      if (visibilityEvents[section] === VisibilityEventType.PARTIAL_TOP || visibilityEvents[section] === VisibilityEventType.SPAN_VIEWPORT) {
        setActiveTab(navigationBarTabList.findIndex(function (tab) {
          return tab.label === section;
        }));
      }
    });
  };
};